// extracted by mini-css-extract-plugin
export var chevronIcon = "_dh-2";
export var teamName = "_dh-1";
export var teamSwitcherButton = "_dh-0";